import React, { useState, useEffect } from "react"
import dayjs from "dayjs"
import { useAppCtx } from "lib/state"
import { appTools, cn } from "lib/utils"
import { useTemplatePreviewCtx } from "lib/units/template/preview/TemplatePreviewProvider"
import SectionHeaderRender from "lib/units/element/SectionHeader/SectionHeaderRender"
import { useRenderStyling, renderStyle } from "lib/hooks/useRenderStyling"

const defaultColumns =  [
  { label: "Trx Date", prop: "TransactionDate", format: "date" },
  { label: "Amount", prop: "Amount", format: "currency" },
  { label: "BIN", prop: "BIN" },
  { label: "Last Four", prop: "LastFour" },
  { label: "Customer Name", prop: "ConsumerName" },
  { label: "Merch Ref", prop: "MerchantReference" },
  { label: "Type", prop: "ActionType" },
  { label: "Trx Id", prop: "ExternalTransactionId" },
  { label: "AuthCode", prop: "AuthorizationCode" }
]

export default function TrxHistoryTableRender(){
  
  const { getElementConfig, getApiFeedData, parseApiData }:any = useTemplatePreviewCtx()
  const config = getElementConfig("trx_history")

  const [ finalConfig, setFinalConfig ] = useState<any>()
  const [ trxHistory, setTrxHistory ] = useState<any[]>() 

  const prepData = () => {
    const initData = getApiFeedData("rp.AdditionalTransactions")
    const finalData = initData
      ?.filter( (trx:any) => finalConfig.allowedTypes.includes(trx.TransactionDetails.ActionType) )
      .sort( (a:any, b:any) => Date.parse(a.TransactionDetails.TransactionDate) - Date.parse(b.TransactionDetails.TransactionDate) )
    setTrxHistory(finalData)
  }

  const formatColumn = (column:any) => {
    if( column.format === "date" ){
      return dayjs(column.value).format("MM/DD/YYYY")
    } else if (column.format === "currency" ) {
      return `$${parseFloat(column.value).toFixed(2)}`
    } else {
      return column.value
    }
  }

  const outerStyling = useRenderStyling("mm-section flex flex-col", "styleObj")
  const outerTableStyling = useRenderStyling("w-full mt-2 mb-4 pl-4", "styleObj")
  const tableStyling = useRenderStyling("w-full border border-solid border-neutral-700 text-sm", "styleObj")
  const rowStyling = useRenderStyling("border-b border-solid border-neutral-700", "styleObj")

  useEffect(() => {
    if( finalConfig){
      prepData()
    }
  },[finalConfig])

  useEffect(() => {
    if( !finalConfig){
      const final_settings = {
        mode: config.mode || "render",
        subdomain: config.subdomain || "",
        title: config.title || "Transaction History",
        columns: config.columns && config.columns.length ? config.columns : defaultColumns,
        allowedTypes: ['sale', 'refund', 'capture'],
        sortBy: config.sortBy || "TransactionDate",
        displayIfNoData: config.displayIfNoData || false
      }
      setFinalConfig(final_settings)
    }
  },[finalConfig])

  
  if( !trxHistory ) return <></>
  return (
    <div id="mm-trx-history" {...outerStyling}>
      
      <SectionHeaderRender title="Transaction History" />

      <div {...outerTableStyling}>
        <table>
          <thead>
            <tr>
              { finalConfig.columns.map( (column:any, idx:number) => {
                const headerStyling = renderStyle(cn("text-sm text-left font-bold pl-1 pr-3", column.width ), "styleObj")
                return (
                  <th key={idx} {...headerStyling}>
                    {column.label}
                  </th>
                )
              }
              )}
            </tr>
            <tr>
              <td colSpan={finalConfig.columns.length} className="border-b border-solid border-neutral-700"></td>
            </tr>
          </thead>
          <tbody>
            { trxHistory.map( (dataObj:any, idx:number) => (
              <tr key={idx} {...rowStyling}>
                { finalConfig.columns.map( (column:any, idx:number) => { 
                  const dataStyling = 
                    renderStyle(cn(
                      "text-left text-sm align-top pl-1 pr-3 pt-0.5 pb-0.5",
                      (column.prop === "MerchantReference" || column.prop === "ExternalTransactionId") ? "break-word" : "",
                      column.width 
                    ), "styleObj")
                  return (
                    <td key={idx} {...dataStyling}>
                      { formatColumn({ ...column, value: dataObj.TransactionDetails[column.prop] }) }
                    </td>
                  )
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}